import * as React from 'react';
import { Text } from 'ilenia';
import { css, StyleSheet } from 'aphrodite';
import { TrustpilotSpinner } from '../';
import Button from './Button';
import { checkTemporaryConfig } from '../../Api/settingsApiClient';
import { SIGNUP_EMAIL_KEY } from '@trustpilot/ecommscript-integrationappauth/external-authentication';

interface AppLockProps {
    integrationKey: string;
}

interface AppLockState {
    loading: boolean;
}

export class AppLock extends React.Component<AppLockProps, AppLockState> {
    public constructor(props: AppLockProps) {
        super(props);
        this.state = {
            loading: true
        };
        this.checkIntegrationKeyExists = this.checkIntegrationKeyExists.bind(this);
    }

    public componentDidMount() {
        this.checkIntegrationKeyExists();
    }

    public checkIntegrationKeyExists() {
        this.setState({ loading: false }, async () => {
            const response = await checkTemporaryConfig(this.props.integrationKey);
            if (!(response && response.exists === true)) {
                localStorage.removeItem(SIGNUP_EMAIL_KEY);
            }
        });
    }

    public onWrongEmailClicked() {
        window.location.href = '/signup';
    }

    public getSignupEmail() {
        let signupEmail: string = '';
        try {
            signupEmail = localStorage.getItem(SIGNUP_EMAIL_KEY) || '';
        } catch (e) { /* empty by purpose */ }
        return signupEmail ? signupEmail : <Text id="modal.appLockEmailNotFound" />;
    }

    public render() {
        const { loading } = this.state;
        return (
            <React.Fragment>
                    {loading ?
                        <TrustpilotSpinner active={loading} height="140px"/> :
                        <div className={css(styles.mainWrapper)}>
                            <div className={css(styles.wrapper)}>
                                <p className={css(styles.textHeader)}>
                                    <Text id="modal.appLockHeader"/>
                                </p>
                                <p className={css(styles.textGroup)}>
                                    <Text id="modal.appLockThanks"/>
                                    <br/>
                                    <Text id="modal.appLockCheckEmail"/>
                                </p>
                                <p className={css(styles.textGroup)}>
                                    <Text id="modal.appLockEmailStart"/><b>{this.getSignupEmail()}</b><Text id="modal.appLockEmailEnd"/>
                                    <br/>
                                    <Text id="modal.appLockWait"/>
                                </p>
                                <p className={css(styles.textGroup)}>
                                <Text id="modal.appLockActivate"/>
                                </p>
                            </div>
                            <div className={css(styles.buttonWrapper)}>
                                <Button
                                    secondaryButton={true}
                                    className={css(styles.button)}
                                    onClick={this.onWrongEmailClicked}
                                    pr={0}
                                    mt={0}
                                >
                                    <Text id="modal.wrongEmail" />
                                </Button>
                            </div>
                        </div>
                    }
            </React.Fragment>
        );
    }
}

const styles = StyleSheet.create({
    button: {
        display: 'flex',
        justifyContent: 'flex-end',
        whiteSpace: 'nowrap',
    },
    mainWrapper: {
        maxWidth: '600px'
    },
    wrapper: {
        backgroundColor: 'white',
        padding: '40px 20px'
    },
    buttonWrapper: {
        backgroundColor: 'white',
        borderTop: '2px solid rgb(239, 243, 246)',
        padding: '20px',
        display: 'grid',
        justifyContent: 'flex-end',
    },
    textHeader: {
        fontSize: '24px',
        fontFamily: 'Lato',
        margin: '0 0 24px 0',
        fontWeight: 'bold',
        color: '#292929',
        lineHeight: '1.43',
    },
    textGroup: {
        fontSize: '14px',
        fontFamily: 'Lato',
        margin: '0 0 24px 0',
        fontWeight: 'normal',
        color: '#292929',
        lineHeight: '1.43',
    },
});
